import { render } from "./SurveyImprovementTable.vue?vue&type=template&id=082650d9&scoped=true"
import script from "./SurveyImprovementTable.vue?vue&type=script&lang=js"
export * from "./SurveyImprovementTable.vue?vue&type=script&lang=js"

import "./SurveyImprovementTable.vue?vue&type=style&index=0&id=082650d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082650d9"]])

export default __exports__